import { rem } from 'polished'
import { styled } from 'styles/stitches.config'

export const WrapLink = styled('div', {
  'ul': {
    marginLeft: rem(20),
    listStyle: 'none'
  },
  'a': {
    margin: rem(5),
    marginLeft: rem(40),
    display: "block",
    fontFamily: '$domine',
    fontSize: rem(20),
    color: '$emerald600',
  },
  'li': {
    marginBottom: rem(5),

    'a': {
      display: "inline",
      fontSize: rem(16),
      color: '$grey800',
      borderBottom: 'dotted 1px #333'
    }
  }
})
